// 添加前导零函数
function padZero(num) {
    return (num < 10 ? '0' : '') + num
}

const Helper = {
    EmptyId() {
        return '00000000-0000-0000-0000-000000000000'
    },
    NewId() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            let r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16)
        })
    },
    FormatTime(str, type) {
        let date = new Date(str)
        let newstr = ""
        switch (type) {
            case "yyyy-mm-dd":
                newstr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDay()}`
                break
            case "yyyy-mm-dd mm:dd":
                newstr = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDay()} ${date.getHours()}:${date.getMinutes()}`
                break
        }
        return newstr
    },
    FloatAdd(arg1, arg2) {
        let r1, r2, m, c
        try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = arg2.toString().split(".")[1].length } catch (e) { r2 = 0 }
        c = Math.abs(r1 - r2)
        m = Math.pow(10, Math.max(r1, r2))
        if (c > 0) {
            let cm = Math.pow(10, c)
            if (r1 > r2) {
                arg1 = Number(arg1.toString().replace(".", ""))
                arg2 = Number(arg2.toString().replace(".", "")) * cm
            } else {
                arg1 = Number(arg1.toString().replace(".", "")) * cm
                arg2 = Number(arg2.toString().replace(".", ""))
            }
        } else {
            arg1 = Number(arg1.toString().replace(".", ""))
            arg2 = Number(arg2.toString().replace(".", ""))
        }
        return (arg1 + arg2) / m
    },
    FloatSub(arg1, arg2) {
        let r1, r2, m, n
        try { r1 = arg1.toString().split(".")[1].length } catch (e) { r1 = 0 }
        try { r2 = arg2.toString().split(".")[1].length }
        catch (e) { r2 = 0 }
        m = Math.pow(10, Math.max(r1, r2))
        n = (r1 >= r2) ? r1 : r2
        return ((arg1 * m - arg2 * m) / m).toFixed(n)
    },
    FloatMul: function (arg1, arg2) {
        let m = 0, s1 = arg1.toString(), s2 = arg2.toString()
        try { m += s1.split(".")[1].length } catch (e) { }
        try { m += s2.split(".")[1].length } catch (e) { }
        return Number(s1.replace(".", "")) * Number(s2.replace(".", "")) / Math.pow(10, m)
    },
    FloatDiv: function (arg1, arg2) {
        let t1 = 0, t2 = 0, r1, r2
        try { t1 = arg1.toString().split(".")[1].length } catch (e) { }
        try { t2 = arg2.toString().split(".")[1].length } catch (e) { }
        r1 = Number(arg1.toString().replace(".", ""))
        r2 = Number(arg2.toString().replace(".", ""))
        return (r1 / r2) * Math.pow(10, t2 - t1)
    },
    CurrentDate() {
        var now = new Date()
        // 获取当前时间的年、月、日、小时、分钟和秒
        var year = now.getFullYear()
        var month = now.getMonth() + 1 // 月份从0開始，所以要加1
        var day = now.getDate()
        var hours = now.getHours()
        var minutes = now.getMinutes()
        var seconds = now.getSeconds()

        // 添加前导零，以确保两位数格式
        month = padZero(month)
        day = padZero(day)
        hours = padZero(hours)
        minutes = padZero(minutes)
        seconds = padZero(seconds)

        // 构建一个字符串表示当前时间，格式为 YYYY-MM-DD HH:MM:SS
        var currentTime = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
        return currentTime
    }
}
export default Helper
